export default [
    {
        path: "/admin/khan-districts",
        name: "khan-district",
        meta: true,
        component: () => import("@/pages/corporate/khan-district/index.vue")
    },
];
